"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageTextLayer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// image with text on top, positioned at the bottom
// todo: convert image to BackgroundImage?
var ImageTextLayer = function (_a) {
    var image = _a.image, heading = _a.heading, children = _a.children;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "position-relative text-white overlay overlay-solid", 
        // until image loads, absolute-fill layer parent needs height
        style: { minHeight: '200px' } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: image, className: "img-fluid", alt: "" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "absolute-fill d-flex flex-column align-items-end z-2" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "w-100 mt-auto p-7" }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "fw-normal lh-1-375 mb-4" }, { children: heading })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "lead opacity-100 mb-0" }, { children: children }))] })) }))] })));
};
exports.ImageTextLayer = ImageTextLayer;
